import FeatureCardSection from "@components/LandingPageComponents/CardSection";
import TestimonialSection from "@components/LandingPageComponents/TestimonialSection";
import Testmon from "@components/LandingPageComponents/testmon-pay";
import TwoButtonHeader from "@components/LandingPageComponents/TwoButtonHeader";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import OfferComponent from "@components/OfferComponent";
import YellowCTAhref from "@components/yellowCTAhref";
import Image from "next/image";
import icon1 from "public/payicon1.png";
import icon2 from "public/payicon2.png";
import icon3 from "public/payicon3.png";
import icon4 from "public/payicon4.png";
import React, { useState } from "react";

const WhatsappPayContent = [
    {
        img: "https://assets.gallabox.com/gb-home/getchat/card1-new.png",

        textWithLogo: [
            {
                title: "Shared Team Inbox",
                desc: (
                    <span className="text-base ">
                        Track and manage all your customer conversations in one place with a unified team inbox and build stronger relationships with your contacts to increase
                        trust, boost sales, and multiply your revenue sustainably.
                    </span>
                ),
            },
        ],
    },

    {
        img: "https://assets.gallabox.com/gb-home/getchat/card2.png",

        textWithLogo: [
            {
                title: "Intelligent Chatbots",
                desc: (
                    <span className="text-base ">
                        Respond to your customers and prospects instantly with Gallabox’s chatbot, providing fast and accurate answers to their queries and delivering exceptional
                        customer service that sets you apart from your competition.
                    </span>
                ),
            },
        ],
    },

    {
        img: "https://assets.gallabox.com/gb-home/getchat/card3.png",

        textWithLogo: [
            {
                title: "Click-to-WhatsApp Ads",
                desc: (
                    <span className="text-base ">
                        Amplify your marketing ROI by generating qualified leads, answering prospects instantly, and increasing trust with the help of interactive Facebook and
                        Instagram ads that take your prospects to WhatsApp.
                    </span>
                ),
            },
        ],
    },

    {
        img: "https://assets.gallabox.com/gb-home/getchat/card4.png",

        textWithLogo: [
            {
                title: "WhatsApp Payments",
                desc: (
                    <span className="text-base ">
                        Bid goodbye to your unpredictable cash flow with WhatsApp Payments on Gallabox. Accelerate your payment cycle using native WhatsApp payments and third-party
                        payment processors like Razorpay, PayU, and more.
                    </span>
                ),
            },
        ],
    },
];

const Getchat: React.FC = () => {
    const [currIndex, setCurrIndex] = useState(0);

    return (
        <NewLayout
            title="Looking for a reliable WhatsApp Business API? Try Gallabox!"
            description="Make a smooth transfer from get.chat to Gallabox."
            canonical="https://gallabox.com/best-getchat-alternative"
            ogAttributes={{ image: "https://gallabox-assets.s3.ap-south-1.amazonaws.com/gb-home/getchat/getchat-og.png" }}
        >
            <div className=" pale-blue-bg-mobile">
                <TwoButtonHeader
                    pageTitle="Best Get.Chat Alternative"
                    mainTitle="Switch from get.chat to Gallabox seamlessly"
                    description="Gallabox is a top-rated WhatsApp Business API provider with shared team inbox, drip marketing, bulk broadcasts, click-to-WhatsApp ads, and more."
                    imageUrl="https://assets.gallabox.com/gb-home/getchat/header.png"
                    buttonText="Sign up for free"
                />

                <div className="pb-20 lg:max-w-7xl mx-auto">
                    <h3 className="text-base text-center font-normal py-2">
                        Trusted by <b>10,000+ businesses</b> in 40+ countries
                    </h3>
                    <ClientLogos />
                </div>

                <FeatureCardSection
                    imageURl="https://assets.gallabox.com/gb-home/getchat/section1.png"
                    subTitle=""
                    title="A Complete WhatsApp Automation Platform"
                    description="With Gallabox, you can capture leads and turn them into leads, set up and run your e-commerce store on WhatsApp, and manage your service offerings. As our product comes with a ton of power-packed features, you can replace 3-6+ tools, including get.chat."
                />

                <FeatureCardSection
                    isImageRightSide
                    imageURl="https://assets.gallabox.com/gb-home/getchat/section2.png"
                    title="Fits Perfectly Into Your Existing Tech Stack"
                    description="The key to hassle-free WhatsApp automation is selecting a platform that offers more than just basic features. While get.chat provides a solid shared team inbox, it may not be cost-effective if you need advanced features like WhatsApp Flows and an intelligent chatbot."
                />

                <FeatureCardSection
                    imageURl="https://assets.gallabox.com/gb-home/getchat/section3.png"
                    title="A Support Team That's Here for You"
                    description="At Gallabox, we are absolutely confident about our unbeatable customer support that is available online, chat, email, and phone support five days a week. Sit back and relax while our agents migrate you from get.chat to Gallabox for free on all annual subscriptions."
                />
                <div className=" lg:pt-40 pt-0" id="scroll-here" />
                <OfferComponent />

                <div className=" pt-20 pb-8">
                    <YellowCTAhref customText={<h2 className="text-2xl md:text-3xl font-bold text-yellow-800">Choose Gallabox over get.chat and see the difference</h2>} />
                </div>

                <section className=" payments-spl-cont mt-20 mb-4 pb-8 md:mt-32 text-center hidden lg:block ">
                    <h2 className="pb-8 md:text-6xl text-4xl font-semibold pb-10 max-w-7xl mx-auto px-5">
                        <span className=" text-black">4 Reasons why</span>&nbsp;
                        <span className=" text-blue-500">get.chat users</span> <span className=" text-black">are making the switch</span>
                    </h2>

                    <div className="button-cont-payments flex-row hidden sm:hidden md:block pb-0">
                        <button onClick={() => setCurrIndex(0)} className={`${currIndex === 0 ? "selected-button-payments" : "button-cont-payments-inactive"}`}>
                            <div className="flex row justify-center">
                                <img src={icon1} alt="Icon 1" className="button-icon" />
                                <p style={{ marginLeft: "10px" }}> Shared Team Inbox</p>
                            </div>
                        </button>
                        <button onClick={() => setCurrIndex(1)} className={`${currIndex === 1 ? "selected-button-payments" : "button-cont-payments-inactive"}`}>
                            <div className="flex row justify-center">
                                <img src={icon2} alt="Icon 2" className="button-icon" />
                                <p style={{ marginLeft: "10px" }}>Intelligent Chatbots</p>
                            </div>
                        </button>
                        <button onClick={() => setCurrIndex(2)} className={`${currIndex === 2 ? "selected-button-payments" : "button-cont-payments-inactive"}`}>
                            <div className="flex row justify-center">
                                <img src={icon3} alt="Icon 3" className="button-icon" />
                                <p style={{ marginLeft: "10px" }}> Click-to-WhatsApp Ads</p>
                            </div>
                        </button>
                        <button onClick={() => setCurrIndex(3)} className={`${currIndex === 3 ? "selected-button-payments" : "button-cont-payments-inactive"}`}>
                            <div className="flex row justify-center">
                                <img src={icon4} alt="Icon 4" className="button-icon" />
                                <p style={{ marginLeft: "10px" }}>WhatsApp Payments</p>
                            </div>
                        </button>
                    </div>

                    <div className="bg-lightBlue rounded-2xl">
                        <div className="flex">
                            <div className="w-1/2 p-14 flex flex-col mt-40 text-left">
                                {WhatsappPayContent[currIndex]?.textWithLogo?.map((data, ind) => (
                                    <div key={data.title + ind} className="mb-8">
                                        <h3 className="font-bold text-4xl">{data?.title}</h3>
                                        <p className="text-lg">{data?.desc}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="w-1/2 flex justify-center items-center">
                                <div className="fi max-w-full max-h-full p-10">
                                    <Image width={521} height={597} src={WhatsappPayContent[currIndex]?.img} alt={WhatsappPayContent[currIndex]?.textWithLogo[0].title} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Testmon
                    TestimonialSectionPropsData={[
                        {
                            img: "https://assets.gallabox.com/gb-home/getchat/mob1.png",
                            title: "Shared Team Inbox",
                            desc: "Track and manage all your customer conversations in one place with a unified team inbox and build stronger relationships with your contacts to increase trust, boost sales, and multiply your revenue sustainably.",
                        },
                        {
                            img: "https://assets.gallabox.com/gb-home/getchat/mob2.png",
                            title: "Intelligent Chatbots",
                            desc: "Respond to your customers and prospects instantly with Gallabox’s chatbot, providing fast and accurate answers to their queries and delivering exceptional customer service that sets you apart from your competition.",
                        },
                        {
                            img: "https://assets.gallabox.com/gb-home/getchat/mob3.png",
                            title: "Click-to-WhatsApp Ads",
                            desc: "Amplify your marketing ROI by generating qualified leads, answering prospects instantly, and increasing trust with the help of interactive Facebook and Instagram ads that take your prospects to WhatsApp.",
                        },
                        {
                            img: "https://assets.gallabox.com/gb-home/getchat/mob4.png",
                            title: "WhatsApp Payments",
                            desc: "Bid goodbye to your unpredictable cash flow with WhatsApp Payments on Gallabox. Accelerate your payment cycle using native WhatsApp payments and third-party payment processors like Razorpay, PayU, and more.",
                        },
                    ]}
                />

                <TestimonialSection
                    TestimonialSectionPropsData={[
                        {
                            companyImg: "https://assets.gallabox.com/gb-home/travelmite-logo.svg",
                            avatarImg: "https://assets.gallabox.com/gb-home/travelmite-comp-logo.png",
                            headerTitle: "A seamless, user-friendly collaborative tool every marketing team needs!",
                            nameText: "Vaseem Ahmed",
                            professionText: "Founder & CEO, Travelmite",
                        },
                        {
                            companyImg: "https://assets.gallabox.com/gb-home/estr-logo.png",
                            avatarImg: "https://assets.gallabox.com/gb-home/estr-owner.png",
                            headerTitle: "The integration process is incredibly straightforward, with no hassles whatsoever. Furthermore, the support provided is excellent.",
                            nameText: "Rohit Shukla",
                            professionText: "Founder, ESTR Holidays",
                        },
                    ]}
                />
            </div>

            <YellowCTAhref customText={<h2 className="text-2xl md:text-3xl font-bold text-yellow-800">Join the list of 1500+ businesses that trust Galalbox</h2>} />
        </NewLayout>
    );
};

export default Getchat;
